import React, { Fragment, useEffect, useState } from 'react'

// Merged imports to be cleaner
import { BarChartComponent, PieChartComponent, LoadingSpinner } from '../components'
import { API_BASE_URL } from '../data'
import {
    DidarAcknowledgementOverviewMetaProps,
    GroupedDataType,
    CategoryType
} from '../data/types'

import { VolunteerViewModal } from '../components/mangement_information/VolunteerViewModal'

type Props = {
    meta: DidarAcknowledgementOverviewMetaProps,

}

export const DidarAcknowledgementOverview = ({ meta }: Props) => {

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [groupedData, setGroupData] = useState<GroupedDataType | null>(null)
    const [isVolunteerViewModalOpen, setIsVolunteerViewModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<CategoryType | null>(null);


    const buildQueryString = () => {
        const params = new URLSearchParams()
        params.append('country', 'eu');

        // Array params often need simpler handling depending on backend,
        // but this standard append loop works for standard Rails/PHP/Node handling
        const fields = ['service_record', 'family_origin', 'availability', 'jamat_khana', 'preference'];
        fields.forEach(f => params.append('fields[]', f));

        return params.toString()
    }

    useEffect(() => {
        const fetchGroupStats = async () => {
            setLoading(true);
            setError(null);
            try {
                const queryString = buildQueryString();
                const response = await fetch(`${API_BASE_URL}/dashboard/stats/volunteer-didar?${queryString}`, { credentials: 'include' })
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`)
                }
                const result = await response.json()
                console.log("Group Data: ", result);
                setGroupData(result);
            } catch (err) {
                setError(err instanceof Error ? err.message : "Error while fetching stats.")
            }
            finally {
                setLoading(false);
            }
        }
        fetchGroupStats();


    }, [])

    const handleCategoryClick = (category: CategoryType) => {
        setIsVolunteerViewModalOpen(true)
        setSelectedCategory(category);
    }

    const handleCategoryClickClose = () => {
        setSelectedCategory(null);
        setIsVolunteerViewModalOpen(false);
    }



    return (
        <Fragment>
            <div className="flex-1 container mx-auto">
                <div className="mb-8">
                    <header className="mb-6">
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                            {meta.title}
                        </h1>
                        <p className="text-gray-600 dark:text-gray-400">
                            {meta.description}
                        </p>
                    </header>
                    <div className="mt-4">

                        {loading && <LoadingSpinner meta={{ loadingText: meta.loadingText }} />}

                        {error && (
                            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
                                <h3 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
                                    {meta.errorTitle}
                                </h3>
                                <p className="text-red-600 dark:text-red-300">{error}</p>
                            </div>
                        )}

                        {!loading && !error && (
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-8 gap-6">

                                {/* IV Positions */}

                                <div className="xl:col-span-6">
                                    <BarChartComponent
                                        title="IV Positions"
                                        data={groupedData ? groupedData['service_record'] : []}
                                        groupBy='service_record'
                                        height="xl"
                                        width="4xl"
                                        onChartClick={handleCategoryClick}


                                    />
                                </div>

                                {/* Family Origin */}

                                <div className="xl:col-span-6">
                                    <BarChartComponent
                                        title="Family Origin"
                                        data={groupedData ? groupedData['family_origin'] : []}
                                        groupBy='family_origin'
                                        height="xl"
                                        width="4xl"
                                        onChartClick={handleCategoryClick}
                                    />
                                </div>

                                {/* Jamatkhana */}
                                <div className="xl:col-span-6">
                                    <BarChartComponent
                                        title="Jamatkhana"
                                        data={groupedData ? groupedData['jamat_khana'] : []}
                                        groupBy='jamat_khana'
                                        height="xl"
                                        width="4xl"
                                        onChartClick={handleCategoryClick}

                                    />
                                </div>

                                {/* Didar Availbility */}

                                <div className="xl:col-span-6">
                                    <BarChartComponent
                                        title="Didar Availability"
                                        data={groupedData ? groupedData['availability'] : []}
                                        groupBy="availability"
                                        height="xl"
                                        width="4xl"
                                        onChartClick={handleCategoryClick}

                                    />
                                </div>

                                {/* Preferences */}

                                <div className="xl:col-span-6">
                                    <BarChartComponent
                                        title="Volunteer Preferences"
                                        data={groupedData ? groupedData['preference'] : []}
                                        groupBy='preference'
                                        height="xl"
                                        width="4xl"
                                        onChartClick={handleCategoryClick}

                                    />
                                </div>

                            </div>
                        )}
                    </div>
                </div>
            </div>

            <VolunteerViewModal
                title={`Volunteers for ${selectedCategory?.field ?? ''} : ${selectedCategory?.value ?? ''}`}
                isOpen={isVolunteerViewModalOpen}
                onCancel={handleCategoryClickClose}
                field={selectedCategory?.field ?? ''}
                value={selectedCategory?.value ?? ''}
            />


        </Fragment>
    )
}